module.exports = __webpack_public_path__ + "media/images/emblems/Moerigen-coat_of_arms-ec6f3199f30e3133b8f65a48315f2a38.svg";